<script>
  import CloseDevice from "./custom/CloseDevice.svelte";
  import { createEventDispatcher } from "svelte";
	import { onMount } from 'svelte';

  export let copy;
  export let logo;

  const dispatch = createEventDispatcher();

  function openLegal() {
    dispatch("open-modal", true);
    log2('3dclick', 'legals open');
    loggin('3dclick', 'legals open');
  }

  
  function hoverHandler() {
    this.style.color = "#149ED9";
  }

  function rollOutHandler() {
    this.style.color = "#a0a0a0";

  }
  
  function animation() {
        var animation_TL = new TimelineMax();
        animation_TL.add("init", "1");
        animation_TL.to(".footer", 2, {opacity: 1, ease: "Circ.easeOut"}, "init");   
    }


  onMount(() => {
        animation();
      });

</script>

<style type="text/scss">
  $color: #ffffff;
  .footer {
    opacity: 0;
    pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
    width: 100%;
    margin: 0 auto;
    color: $color;
    height: 15%;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    z-index: 10;
    
    .container {
      width: 100%;
      max-width: 1400px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      transform: translateY(-10px);

      .close-legal-container {
        text-align: left;
        transform:translateY(-5px);

        .close-container {
          display: flex;
        }
      }

      .legal-container {
        font-size: 0.55rem;
        letter-spacing: 0.5px;
        margin-top: 0.5rem;
        color: #a0a0a0;

        .legal-link {
          pointer-events: all;
          -webkit-user-select: all;
          -moz-user-select: all;
          -ms-user-select: all;
          user-select: all;          
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    .evo-checkmark {
      width: 9rem;
    }
  }
</style>

<div class="footer">
  <div class="container">
    <div class="close-legal-container">
      <div class="close-container">
        <CloseDevice {copy} />
        <div />
      </div>
      <div class="legal-container">
        <p>{copy.legal.copy}</p>
        <p class="legal-link" on:click={openLegal} on:mouseenter={hoverHandler} on:mouseleave={rollOutHandler}>{copy.legal.link}</p>
      </div>
    </div>
    <div class="evo-checkmark">
      <img class="img" src={logo} alt="evo checkmark" />
    </div>
  </div>
</div>
